import { CustomCellRendererProps } from "ag-grid-react";

// The functions in this file were migrated from APPRETIO PY. Consider reviewing and refactoring in the future. Only used  for testing purposes.
const icons = {
  active: <i className="fa fa-check-circle" style={{ color: "green" }} />,
  Deactivate: <i className="fa fa-times-circle" style={{ color: "red" }} />,
  unknown: <i className="fa fa-question-circle" style={{ color: "grey" }} />,
  partlyActive: <i className="fa fa-check-circle" style={{ color: "grey" }} />
};

export function activeDeactivateCellRenderer(params: CustomCellRendererProps) {
  // Determine the appropriate icon based on the row's state.
  // For parent rows, use helperActiveDeactivateHierarchy to evaluate aggregated data.
  // For child rows, use helperActiveDeactivate to evaluate individual row data.
  if (params.node.aggData) {
    return helperActiveDeactivateHierarchy(params);
  } else {
    return helperActiveDeactivate(params);
  }
}

function helperActiveDeactivateHierarchy(params: CustomCellRendererProps) {
  if (
    params.node.allChildrenCount !== null &&
    params.node.allChildrenCount > 0
  ) {
    if (params.node.allLeafChildren) {
      // Check if allLeafChildren exists
      if (params.value === params.node.allLeafChildren.length) {
        return icons.active;
      } else if (params.value === 0) {
        return icons.Deactivate;
      } else if (
        typeof params.value === "number" &&
        params.value > 0 &&
        params.value < params.node.allLeafChildren.length
      ) {
        return icons.partlyActive;
      } else {
        return icons.unknown;
      }
    } else {
      // Handle the case where allLeafChildren is null or undefined
      return icons.unknown; // Or some other appropriate icon/value
    }
  } else {
    return icons.unknown;
  }
}

function helperActiveDeactivate(params: CustomCellRendererProps) {
  // Helper function for activeDeactivateCellRenderer
  if (params.value === 1) {
    return icons.active;
  }
  // if value is between 0 and 0.5, then return red icon
  else if (
    typeof params.value === "number" &&
    params.value >= 0 &&
    params.value < 0.5
  ) {
    return icons.Deactivate;
  }
  // if value is between 0.5 and 1, then return grey checkmark
  else if (
    typeof params.value === "number" &&
    params.value >= 0.5 &&
    params.value < 1
  ) {
    return icons.partlyActive;
  }
  // if value is unknown, then return grey question mark
  else {
    return icons.unknown;
  }
}
